import { IdentificationTypeResponse } from '../../types/IdentificationType';
import { PARAMETERS } from '../endpoints';
import request from '../request';

/**
 * Obtiene los tipos de identificación disponibles desde el endpoint genérico
 * `/maintainers-portal/global-parameters/identification-types`.
 *
 * Cuando se provee `countryId`, el backend filtra a los tipos globales
 * (countryId IS NULL) o los que pertenecen al país indicado. Cuando se omite,
 * devuelve todos los tipos.
 */
export function getIdentificationTypes(countryId?: string | null) {
  return request<IdentificationTypeResponse>(PARAMETERS.IDENTIFICATION_TYPES, {
    params: countryId ? { countryId } : undefined,
  });
}
